module.exports = __webpack_public_path__ + "img/grey_connection.a33f8a85.svg";